import { useContext } from 'react';
import ThemeContext from '../Context';
export default function useTheme() {
  return useContext(ThemeContext);
}